/** Pure display helpers for messages: relative/absolute timestamps and the quick-reaction emoji set. */
export function timeAgo(ts?: string) {
  if (!ts) return '';
  try {
    const d = new Date(ts);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);
    if (s < 60) return `${s}s ago`;
    const m = Math.floor(s / 60); if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60); if (h < 24) return `${h}h ago`;
    const dd = Math.floor(h / 24); if (dd < 7) return `${dd}d ago`;
    return d.toLocaleString();
  } catch { return ''; }
}

export function formatTime(ts?: string) {
  if (!ts) return '';
  try {
    const d = new Date(ts);
    // Include date + time for clarity in DMs and channels
    // Example: Jan 05, 3:42 PM
    return d.toLocaleString([], {
      year: 'numeric', month: 'short', day: '2-digit',
      hour: '2-digit', minute: '2-digit'
    } as Intl.DateTimeFormatOptions);
  } catch { return ''; }
}

export function getQuickEmojis(): string[] {
  try {
    const raw = localStorage.getItem('echo:profile:reactions');
    const list = raw ? JSON.parse(raw) : null;
    if (Array.isArray(list) && list.length > 0 && list.every((x: any) => typeof x === 'string' && x.trim())) {
      return list as string[];
    }
  } catch { /* noop */ }
  try {
    const favRaw = localStorage.getItem('favEmojis');
    const fav = favRaw ? JSON.parse(favRaw) : null;
    if (Array.isArray(fav) && fav.length === 6 && fav.every((x:any) => typeof x === 'string' && x.trim())) {
      return fav as string[];
    }
  } catch { /* noop */ }
  try {
    const raw = localStorage.getItem('emojiRecent');
    const list: string[] = raw ? JSON.parse(raw) : [];
    const valid = list.filter((ch) => typeof ch === 'string' && ch.trim() && ch !== '??' && ch !== '?');
    const fallback = ['\uD83D\uDC4D', '\u2764\uFE0F', '\uD83D\uDE02'];
    const uniq = Array.from(new Set([...valid.slice(-5).reverse(), ...fallback]));
    return uniq.slice(0, 6);
  } catch { return ['\uD83D\uDC4D', '\u2764\uFE0F', '\uD83D\uDE02']; }
}
